<form class="supply-order-request-container" [formGroup]="supplyForm">
  <h2>Supply order request</h2>
  <div>
    <p>
      Patient:
      <span class="text-bold"
        >{{ data?.request_body?.patient?.firstName }} {{ data?.request_body?.patient?.lastName }}</span
      >
    </p>
    <p>
      Device:
      <span class="text-bold">{{
        data?.request_body?.device?.sku_name || data?.request_body?.device?.sku_display
      }}</span>
    </p>
    <p *ngIf="data?.request_body?.supply_name">
      Supply:
      <span class="text-bold">{{ data?.request_body?.supply_name }}</span>
    </p>
  </div>
  <mat-form-field appearance="outline">
    <mat-label>Comments</mat-label>
    <textarea matInput placeholder="Comments" formControlName="comments" rows="5"></textarea>
  </mat-form-field>
  <div fxLayout="row" fxLayoutAlign="flex-end center" fxLayoutGap="1rem">
    <button mat-raised-button color="accent" [disabled]="showProgressBar || supplyForm.invalid" (click)="reject()">
      Reject
    </button>
    <button *ngIf="data?.type === 'supply_order'" mat-raised-button color="default" (click)="close()">Close</button>
    <mat-spinner [diameter]="16" *ngIf="showProgressBar"></mat-spinner>
  </div>
</form>
